/* eslint-disable @typescript-eslint/no-unused-vars */
import React from 'react';
import { MetricEntity } from '../Model/MetricsModel';

const TenantContext = React.createContext({
  setSelectedTenant: (tenant: string) => {},
  setSelectedFarm: (farmId: number) => {},
  setSelectedEntity: (metricEntity: MetricEntity) => {},
});
export default TenantContext;
